var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoGraficoBorda01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    d: "M31.5,35.3h-27c-2.1,0-3.9-1.7-3.9-3.9v-27c0-2.1,1.7-3.9,3.9-3.9h27c2.1,0,3.9,1.7,3.9,3.9v27 C35.3,33.6,33.6,35.3,31.5,35.3z M4.5,4.5v27h27v-27H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2_4_",
    d: "M27.6,27.6h-3.9V14.1h3.9V27.6z M19.9,27.6h-3.9V8.4h3.9V27.6z M12.2,27.6H8.4V18h3.9V27.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGraficoBorda01);
export default __webpack_public_path__ + "static/media/ico-grafico-borda-01.b02f6f1f086418579d5d42436c7f987d.svg";
export { ForwardRef as ReactComponent };